import React from "react";
import ReportDataTable from "./ReportDataTable";

const columns = [
  { label: "S/N", key: "serial", render: (row) => row.serial },
  { label: "Section", key: "section_name" },
  { label: "Tables", key: "total_tables" },
  { label: "Amount(Rs.)", key: "total_amount", render: (row) => Number(row.total_amount || 0).toFixed(2) },
  { label: "CGST(Rs.)", key: "total_cgst", render: (row) => Number(row.total_cgst || 0).toFixed(2) },
  { label: "SGST(Rs.)", key: "total_sgst", render: (row) => Number(row.total_sgst || 0).toFixed(2) },
  { label: "Discount(Rs.)", key: "total_discount", render: (row) => Number(row.total_discount || 0).toFixed(2) },
  { label: "Grand Total(Rs.)", key: "total_grand_total", render: (row) => Number(row.total_grand_total || 0).toFixed(2) },
];

const SectionReport = ({ rows = [], loading }) => (
  <ReportDataTable
    columns={columns}
    rows={rows.map((row, index) => ({ ...row, serial: index + 1 }))}
    loading={loading}
    emptyMessage="No section report data found."
  />
);

export default SectionReport;
